import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { AssignInspection, InspectionStatuses, InspectionView, InspectionTypes as ITPS } from '../shared/models/Inspection';
import { InspectionService } from '../shared/services/inspection.service';
import * as Constants from '../../models/Constants';
import { UserService } from '../../services/user.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { UserDto } from '../../models/User';
import { CommonService } from '../../shared/services/common.service';
import { AccountService } from '../../services/account.service';
import { NgForm } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertService } from '../../shared/services/alert.service';
import { Assignee, ProductType } from '../../models/CommonModels';
import { ActivatedRoute } from '@angular/router';
import { UtilsService } from '../../shared/services/utils.service';

@Component({
  selector: 'app-inspection-list',
  templateUrl: './inspection-list.component.html',
  styleUrls: ['./inspection-list.component.css']
})
export class InspectionListComponent implements OnInit {

  @ViewChild('assignForm') assignForm: NgForm;
  @ViewChild(DataTableDirective, { static: true })
  datatableElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  inspections: InspectionView[] = [];
  //TODO: create a separate component for assigning
  public minDate: Date = new Date();
  public dueDatePicker: Date;
  public startDatePicker: Date;
  public bsValue: Date = new Date();
  public bsConfig: Partial<BsDatepickerConfig>;
  public inspectors: UserDto[] = [];
  public taskForceMembers: UserDto[] = [];
  public tobeAssignedUsers: UserDto[] = [];
  public filteredNonPrimaryInspectors: UserDto[] = [];
  public assignedUser: UserDto = null;
  public previousPrimaryInspector: UserDto = null;
  public assignedInspectorIDs: Array<number> = [];
  public productTypes : Array<ProductType> = [];
  public selectedInspection: InspectionView;
  public modalRef: BsModalRef;
  public isAbroadCGMP : boolean = false;
  public isLocalGMP : boolean = false;
  public isGMP : boolean = false;
  public inspectionTypeList = [];
  public selectedInspectionTypeCode = "ALL";
  public isAbroadWaiver: boolean = false;
  public gmpOfficers: UserDto[] = [];
  public isApplicant: boolean = false;
  public constants: any = Constants;
  public gmpTypes : string[] = [ITPS.NEW_LOCAL_GMP_INSPECTION, ITPS.LOCAL_GMP_RENEWAL_INSPECTION, ITPS.NEW_ABROAD_CGMP_INSPECTION,
    ITPS.ABROAD_CGMP_RENEWAL_INSPECTION, ITPS.NEW_ABROAD_CGMP_INSPECTION_WAIVER, ITPS.ABROAD_CGMP_INSPECTION_WAIVER_RENEWAL];
  public assignmentType: string = "";

  constructor(private inspectionService: InspectionService, private userService: UserService, private commonService: CommonService,
    private accountService: AccountService, private modalService: BsModalService, private spinner: NgxSpinnerService, 
    private alertService: AlertService, private activatedRoute: ActivatedRoute, private utilService: UtilsService) { }

  ngOnInit() {
    this.commonService.getProductTypes().subscribe(resp => this.productTypes = resp);
    let currentInspectionType = this.activatedRoute.snapshot.params['inspectionTypeCode'];
    this.isAbroadCGMP = currentInspectionType == "ABROADCGMP" || currentInspectionType == "ABROADCGMPWAIVER";
    this.isLocalGMP = currentInspectionType == "LOCALGMP";
    this.isAbroadWaiver = currentInspectionType == "ABROADCGMPWAIVER";
    this.isGMP = this.isLocalGMP || this.isAbroadCGMP;
    this.isApplicant = this.accountService.isUserApplicant() || this.accountService.isUserRegistrant();

    if(!this.isGMP && this.isUserInspectionTeamLeader()){
      this.userService.getInspectors(this.accountService.getUserBranchOffice().id).subscribe(resp => {
        this.inspectors = resp;
        this.inspectors.map( (user) => { user.fullName = user.firstName + ' ' + user.lastName; return user; } );
      });
    }

    if(this.isGMP && (this.isUserDirector() || this.accountService.isUserGMPCoordinator())){
      //TODO: retrieve by branch when branches other than EFDA start using GMP Inspection
      this.userService.getUsersByRole(Constants.CGMP_INSPECTOR).subscribe(resp => {
        this.inspectors = resp;
        this.inspectors.map( (user) => { user.fullName = user.firstName + ' ' + user.lastName; return user; } );
      }); 

      if(this.isGMP) {
        this.userService.getUsersByRole(Constants.GMP_TASK_FORCE).subscribe(resp => {
          this.taskForceMembers = resp;
          this.taskForceMembers.map( (user) => { user.fullName = user.firstName + ' ' + user.lastName; return user; } );
        }); 
      }
    }
    
    if(this.isGMP && this.accountService.isUserGMPCoordinator()){
      this.userService.getUsersByRole(Constants.GMP_OFFICER).subscribe(resp => {
        this.gmpOfficers = resp;
        this.gmpOfficers.map( (user) => { user.fullName = user.firstName + ' ' + user.lastName; return user; } );
      });
    }
   
    this.dtOptions = this.inspectionService.getInspectionListDataTable(this.inspections, this.isAbroadCGMP, this.isLocalGMP);
    this.activatedRoute.params.subscribe(params => {
      const inspectionTypeCode = params['inspectionTypeCode'];
      this.isAbroadWaiver = inspectionTypeCode == "ABROADCGMPWAIVER"
      this.selectedInspectionTypeCode = this.isAbroadCGMP || this.isLocalGMP ? "ALL" : inspectionTypeCode;
      this.setInspectionTypeDropDown();
      this.inspectionTypeChanged();
    });
  }

  getStatusColor(status) {
    return Constants.COLOR_MAP[status];
  }

  getDateString(dateStr) {
    if (!dateStr) {
      return '';
    }
    let date = new Date(dateStr);
    return date.toLocaleDateString('en-US', {year : 'numeric', month: 'short', day: 'numeric'});
  }

  primaryInspectorChanged() {
      let index = this.filteredNonPrimaryInspectors.findIndex(u => u.id === this.assignedUser.id);
      this.filteredNonPrimaryInspectors.splice(index, 1);
      if (this.previousPrimaryInspector != null) {
        this.filteredNonPrimaryInspectors.push(this.previousPrimaryInspector);
      }
      this.filteredNonPrimaryInspectors = this.filteredNonPrimaryInspectors.slice(0); // ng-select only listens to changes if it is a new array
  
      this.filteredNonPrimaryInspectors.sort( (a, b) => {
        let name1 = a.fullName.toUpperCase();
        let name2 = b.fullName.toUpperCase();
        if (name1 < name2) {
          return -1;
        }
        if (name1 > name2) {
          return 1;
        }
        return 0;
      });
  
      this.previousPrimaryInspector = this.assignedUser;
      let primaryIndex = this.assignedInspectorIDs.findIndex(id => id === this.assignedUser.id);
      if (primaryIndex !== -1) {
        this.assignedInspectorIDs.splice(primaryIndex, 1);
        this.assignedInspectorIDs = this.assignedInspectorIDs.slice(0); // ng-select only listens to changes if it is a new array
      }
  }

  getFacilityDepartment() {
    let facilityProductTypeName  = this.productTypes.find(p => p.name.trim() === this.selectedInspection.productType.trim()).name;
    if (facilityProductTypeName === Constants.PRODUCT_TYPE_FOOD) {
      return Constants.FOOD_DEPARTMENT;
    } else if (facilityProductTypeName === Constants.PRODUCT_TYPE_TOBACCO) {
      return Constants.TOBACCO_DEPARTMENT;
    } else {
      return Constants.MED_DEPARTMENT;
    }
  }

  showAssignUserModal(inspectionId, template: TemplateRef < any > ) {
    this.dueDatePicker = null;
    this.assignedInspectorIDs = [];
    this.assignedUser = null;
    this.selectedInspection = this.inspections.find(a => a.id === inspectionId);
    //const appDeptCode = this.getFacilityDepartment();

    /*this.filteredPrimaryInspectors = this.inspectors.filter(u => (u.userDepartments.map(
        	  p => p.department.departmentCode).indexOf(appDeptCode) !== -1));*/
    //TODO: handle inspector filtering that works for all inspection types
    if(this.showOfficerAssignButton(this.selectedInspection)) {
      this.tobeAssignedUsers = this.gmpOfficers;
      this.assignmentType = "SCREENING";
    } else if(this.showTaskForceAssignButton(this.selectedInspection)) {
      this.tobeAssignedUsers = this.taskForceMembers;
      this.filteredNonPrimaryInspectors = this.tobeAssignedUsers.slice(0);
      this.assignmentType = "TASKFORCE";
    } else {
      this.tobeAssignedUsers = this.inspectors;
      this.filteredNonPrimaryInspectors = this.tobeAssignedUsers.slice(0);
      this.assignmentType = "INSPECTION";
    }

    this.previousPrimaryInspector = null;

    this.modalRef = this.modalService.show(template, {backdrop: 'static', keyboard: false});
  }

  assignToInspection(){
    this.spinner.show();

    let assignees: Assignee[] = [];
    assignees.push(new Assignee(this.assignedUser.id, true));
    this.assignedInspectorIDs.forEach(id => {
      assignees.push(new Assignee(id, false));
    });    

    let assignmentData = new AssignInspection( this.selectedInspection.id, assignees, this.dueDatePicker.toISOString(), 
        this.startDatePicker?.toISOString(), this.assignmentType);
        
    this.inspectionService.assignToInspection(assignmentData).subscribe(
      resp => {
        console.log('res ', resp);
        this.spinner.hide();
        if (resp) {
          this.selectedInspection.assignedUser = this.assignedUser.fullName;
          this.selectedInspection.assignedUserID = this.assignedUser.id;
          this.selectedInspection.dueDate = assignmentData.dueDate;
          this.alertService.success('Inspection Assigned to user successfully');
        } else {
          this.alertService.error('Unable to assign Inspection, please try again later!');
        }
        this.modalRef.hide();
      },
      error => {
        this.spinner.hide();
        this.alertService.error('Unable to assign Inspection, please try again later!');
        this.modalRef.hide();
      },
      () => {
        this.dueDatePicker = null;
        this.assignedInspectorIDs = [];
        this.assignedUser = null;
      }
    );
  }

  showInspectorAssignButton(inspection : InspectionView){ 
    console
    return (!this.isAbroadCGMP && this.isUserInspectionTeamLeader() && [InspectionStatuses.SCREENING_PASSED,
      InspectionStatuses.ASSIGNED_TO_INSPECTOR, InspectionStatuses.FORWARDED_FOR_FOLLOW_UP_INSPECTION].indexOf(inspection.inspectionStatusCode) !== -1)
      || ((this.isAbroadCGMP || this.isLocalGMP) && this.isUserDirector() && [InspectionStatuses.PAYMENT_APPROVED, InspectionStatuses.CAPA_PLAN_SUBMITTED
        ,InspectionStatuses.SITE_INSPECTION_REPORT_SUBMITTED,
       InspectionStatuses.ASSIGNED_TO_INSPECTOR, InspectionStatuses.FORWARDED_FOR_FOLLOW_UP_INSPECTION].indexOf(inspection.inspectionStatusCode) != -1)
             || ((this.isAbroadCGMP ||this.isLocalGMP) && this.accountService.isUserGMPCoordinator()  && 
             [ InspectionStatuses.CAPA_PLAN_SUBMITTED
              ,InspectionStatuses.IMPLEMENTATION_REPORT_SUBMITTED
              , InspectionStatuses.CAPA_PLAN_AND_IMPLEMENTATION_EVIDENCE_SUBMITTED,
              ,InspectionStatuses.ASSIGNED_TO_INSPECTOR_AFTER_INSPECTION
              ,InspectionStatuses.ASSIGNED_TO_INSPECTOR_AFTER_IMPLEMENTATION_EVIDENCE
            ].indexOf(inspection.inspectionStatusCode) != -1)
        
  }

  showOfficerAssignButton(inspection : InspectionView){
    return (this.gmpTypes.indexOf(inspection.inspectionTypeCode) != -1 && this.accountService.isUserGMPCoordinator() && 
    [InspectionStatuses.REQUESTED_CODE, InspectionStatuses.ASSIGNED_TO_GMP_OFFICER].indexOf(inspection.inspectionStatusCode) != -1);
  }

  showTaskForceAssignButton(inspection: InspectionView) { 
    return (this.isAbroadCGMP|| this.isLocalGMP) && this.isUserDirector() && [InspectionStatuses.INSPECTED_CODE, 
      InspectionStatuses.INSPECTION_FAILED_CODE , InspectionStatuses.INSPECTION_REPORT_SUBMITED].indexOf(inspection.inspectionStatusCode) != -1;
  }

  getPlaceholder(inspection : InspectionView){
      if(this.showOfficerAssignButton(inspection)) {
        return "Select Officer";
      } else if(this.showTaskForceAssignButton(inspection)) {
        return "Select Task Force Member";
      } else {
        return "Select Inspector";
      }
  }

  isUserInspectionTeamLeader(): boolean {
    return this.accountService.isUserInspectionTeamLeader();
  }

  isUserDirector(): boolean {
    return this.accountService.isUserDirector();
  }

  reloadList() {
    if (this.datatableElement.dtInstance) {
      this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.draw();
      });
    }
  }

  inspectionTypeChanged(){
    if(this.selectedInspectionTypeCode == "ALL"){
      if(this.isLocalGMP){
        this.inspectionService.inspectionTypeCodes = [ITPS.NEW_LOCAL_GMP_INSPECTION, ITPS.LOCAL_GMP_RENEWAL_INSPECTION];
      }else if(this.isAbroadCGMP){
        if(!this.isAbroadWaiver){
          this.inspectionService.inspectionTypeCodes = [ITPS.NEW_ABROAD_CGMP_INSPECTION, ITPS.ABROAD_CGMP_RENEWAL_INSPECTION];
        } else {
          this.inspectionService.inspectionTypeCodes = [ITPS.NEW_ABROAD_CGMP_INSPECTION_WAIVER,ITPS.ABROAD_CGMP_INSPECTION_WAIVER_RENEWAL];
        }
      }
      this.inspectionService.legacyDataFilter = false;
    } else if(this.selectedInspectionTypeCode == "LEGACY") {
      if(this.isLocalGMP){
        this.inspectionService.inspectionTypeCodes = [ITPS.NEW_LOCAL_GMP_INSPECTION, ITPS.LOCAL_GMP_RENEWAL_INSPECTION];
      }else if(this.isAbroadCGMP){
        if(!this.isAbroadWaiver){
          this.inspectionService.inspectionTypeCodes = [ITPS.NEW_ABROAD_CGMP_INSPECTION, ITPS.ABROAD_CGMP_RENEWAL_INSPECTION];
        } else {
          this.inspectionService.inspectionTypeCodes = [ITPS.NEW_ABROAD_CGMP_INSPECTION_WAIVER,ITPS.ABROAD_CGMP_INSPECTION_WAIVER_RENEWAL];
        }
      }
      this.inspectionService.legacyDataFilter = true;
    } else {
      this.inspectionService.inspectionTypeCodes = [this.selectedInspectionTypeCode];
      this.inspectionService.legacyDataFilter = false;
    }
    
    this.reloadList();
  }

  setInspectionTypeDropDown(){
    if(this.isAbroadCGMP){
      if(!this.isAbroadWaiver){
        this.inspectionTypeList = [ {code : "ALL", name: "All"},
        {code : ITPS.NEW_ABROAD_CGMP_INSPECTION, name: ITPS.codeToName(ITPS.NEW_ABROAD_CGMP_INSPECTION)},
        {code : ITPS.ABROAD_CGMP_RENEWAL_INSPECTION, name: ITPS.codeToName(ITPS.ABROAD_CGMP_RENEWAL_INSPECTION)},
        {code : "LEGACY", name: "Legacy"}];
      } else {
        this.inspectionTypeList = [ {code : "ALL", name: "All"},
        {code : ITPS.NEW_ABROAD_CGMP_INSPECTION_WAIVER, name: ITPS.codeToName(ITPS.NEW_ABROAD_CGMP_INSPECTION_WAIVER)},
        {code : ITPS.ABROAD_CGMP_INSPECTION_WAIVER_RENEWAL, name: ITPS.codeToName(ITPS.ABROAD_CGMP_INSPECTION_WAIVER_RENEWAL)},
        {code : "LEGACY", name: "Legacy"}]
      }

    } else if(this.isLocalGMP){
      this.inspectionTypeList = [ {code : "ALL", name: "All"},
        {code : ITPS.NEW_LOCAL_GMP_INSPECTION, name: ITPS.codeToName(ITPS.NEW_LOCAL_GMP_INSPECTION)},
        {code : ITPS.LOCAL_GMP_RENEWAL_INSPECTION, name: ITPS.codeToName(ITPS.LOCAL_GMP_RENEWAL_INSPECTION)},
        {code : "LEGACY", name: "Legacy"}
      ];
    }
  }

  isDueDatePassed(inspection: InspectionView) : boolean {
    let dueDate = new Date(inspection.dueDate);
    let v = this.utilService.compareDates(dueDate, new Date()) === -1;
    return v;
  }

  highlightRow(insp: InspectionView){
    return this.isGMP && [InspectionStatuses.ASSIGNED_TO_INSPECTOR, InspectionStatuses.ASSIGNED_TO_GMP_OFFICER,  
      InspectionStatuses.ASSIGNED_TO_TASK_FORCE, InspectionStatuses.ASSIGNED_TO_INSPECTOR_AFTER_INSPECTION, InspectionStatuses.ASSIGNED_TO_INSPECTOR_AFTER_IMPLEMENTATION_EVIDENCE].includes(insp.inspectionStatusCode) && this.isDueDatePassed(insp);
  }
}
